import BaseComponent from 'scripts/BaseComponent.js';
import { AccessibilityHelper } from 'scripts/accessibility/accessibilityHelper';
import UnderlayHelper from '../../global/underlay-helper';

export default class AccountDrawer extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      body: 'body',
      open: '.js-accountDrawerOpen',
      close: '.js-accountDrawerClose',
    };

    this.dom = {
      $component: component,
      $body: document.querySelector(this.refs.body),
      $open: document.querySelector(this.refs.open),
      $close: this.$get(this.refs.close),
    };

    this.state = {
      animationDuration: 500,
      accountDrawerOpen: false,
      underlayHelper: new UnderlayHelper({ overNav: true }),
      openAccountDrawerEvent: 'openaccountdrawer',
      closeMobileNavDrawerEvent: 'closemobilenavdrawer',
      toggleAccountDrawerFormEvent: 'toggleaccountdrawerform',
      openClass: 'is-open',
      activeClass: 'is-active',
      noScrollClass: 'no-scroll',
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();
    this.setOnCustomEvent(state.openAccountDrawerEvent, this.open);
    this.setOnCustomEvent(state.toggleAccountDrawerFormEvent, this.resetFocusTrap);
    this.setClick(dom.$close, this.close);
    this.setOnEscapeKey(this.close);
    state.underlayHelper.addClickListener(this.close.bind(this));
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
  }

  close() {
    const { dom, state } = this;
    if (state.accountDrawerOpen) {
      dom.$component.classList.remove(state.openClass);
      dom.$component.setAttribute('aria-expanded', 'false');
      dom.$component.setAttribute('aria-hidden', 'true');
      state.accountDrawerOpen = false;
      state.focusTrap.unset();
      dom.$open.focus();
      dom.$body.classList.remove(state.noScrollClass);

      setTimeout(() => {
        state.underlayHelper.close();
        dom.$component.classList.remove(state.activeClass);
      }, state.animationDuration);
    }
  }

  open() {
    const { dom, state } = this;
    this.dispatch(state.closeMobileNavDrawerEvent);
    dom.$component.classList.add(state.activeClass);
    dom.$component.setAttribute('aria-expanded', 'true');
    dom.$component.setAttribute('aria-hidden', 'false');
    state.focusTrap.set();
    state.accountDrawerOpen = true;
    dom.$body.classList.add(state.noScrollClass);

    setTimeout(() => {
      state.underlayHelper.open();
      dom.$component.classList.add(state.openClass);
    }, 0);
  }

  resetFocusTrap() {
    const { dom, state } = this;
    if (state.focusTrap) { state.focusTrap.unset(); }
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
    state.focusTrap.set();
  }
}
